export const TennisMoneyLine1x2 = `
{{var event_count = 0;}}
{{var options = data.options;}}
{{var isBlockedLiveSport = data.isBlockedLiveSport;}}
{{var blockedLiveLeagues = data.blockedLiveLeagues;}}
{{var periodsRightLayout = data.periodsRightLayout;}}
{{var altMainLabel = data.altMainLabel;}}
{{var periodsDescription = data.periodsDescription;}}
{{var isNewTennis = data.isNewTennis;}}
{{var isLiveEvent = data.isLiveEvent;}}

{{? data.sports}}
    {{~data.sports :sp:sp_index}}
    {{var sportGroup =SportGroup.stringOf(sp[4]).toLowerCase();}}
    {{var isSoccerType = sp[4] === SportGroup.SOCCER;}}
    {{var hasDrawML = sp[7];}}
    {{var ot = data.ot;}}
    {{var isParlay = (data.isParlay || data.isParlayMarket);}}
    <div class='single-line line-1x2 col-{{=hasDrawML?6:4}}'>
    <div class="freeze-table-header"></div>
    <table class="events events-header{{? options.isParlayMarket}} isParlayMarket{{?}} sp{{=sp[0]}}">
        <tr>
            <td class="col-icons main-icons border-left border-bottom col-border-left" rowspan="2"></td>
            <td class="col-time main-time border-bottom-right" rowspan="2">{{=i18n('Time')}}</td>
            <td class="col-fav main-fav border-bottom" rowspan="2"></td>
            <td class='col-name main-name border-bottom-right' rowspan="2"><span>{{=i18n('Event')}}</span></td>
            <td class="main-fulltime border-bottom-right" colspan="{{=!hasDrawML? 2 : 3}}">{{=i18n('Sets')}}</td>
            <td class="main-halftime border-bottom-right" colspan="{{=!hasDrawML? 2 : 3}}">{{=i18n('Games')}}</td>
            <td class="col-more main-more border-bottom-right col-border-right" rowspan="2" title="{{=i18n('More')}}">&nbsp;</td>
        </tr>
        <tr>
            <td class="odds main-odds border-bottom-right">{{=i18n('Player 1')}}</td>
            {{? hasDrawML}}
                <td class="odds main-odds border-bottom-right">{{=i18n(sportGroup, 'Draw')}}</td>
            {{?}}
            <td class="odds main-odds border-bottom-right">{{=i18n('Player 2')}}</td>
            <td class="odds main-odds border-bottom-right">{{=i18n('Player 1')}}</td>
            {{? hasDrawML}}
                <td class="odds main-odds border-bottom-right">{{=i18n(sportGroup, 'Draw')}}</td>
            {{?}}
            <td class="odds main-odds border-bottom-right">{{=i18n('Player 2')}}</td>
        </tr>
    </table>
    {{var leagues = sp[2];}}
    {{~leagues :lg:lg_index}}
    {{var leagueName = lg[1];}}
    {{var leagueId = lg[0];}}
    {{var isBlockedLiveLeague = blockedLiveLeagues.indexOf(leagueId) > -1;}}
    <div class="league" id='lg{{=leagueId}}'>
        <a class="bookmark "><i data-league-id="{{=leagueId}}" class='fav  icon'></i></a>
        <div class="fav-custom-tooltip ">
            <div class="tooltip-wrapper">
                <span class="tooltip-text">{{=i18n('You have reached the maximum favorites added.')}}</span>
            </div>
        </div>
        <span>
          {{=leagueName}}
        </span>
        <a class="refresh-odds" data-live="{{=data.isLive}}"><i class='icon refresh-odds'></i></a>
    </div>
    <div>
    {{var events = lg[2] || [];}}
    {{var eParentLeague = fetchParentId(events);}}
    {{var parentEvents = events.filter(function(e){ return e[28]==0});}}
    {{var notParentEvents = events.filter(function(e){ return e[28] != 0});}}
    {{~eParentLeague :parentEvent:parentEventIndex}}
      {{var evParent = parentEvents.find(function(ev) {return ev[0] === parentEvent}) || [];}}
      {{var childEvents = notParentEvents.filter(function(e){ return e[28] === parentEvent});}}
      {{var isSetChildEvent = childEvents.some(function(ev){ return ev[28] === evParent[0] && ev[27] === "Sets";});}}
      {{var isGameChildEvent = childEvents.some(function(ev){ return ev[28] === evParent[0] && ev[27] === "Games";});}}
      {{var isRegularChildEvent = childEvents.some(function(ev){ return ev[28] === parentEvent && ev[27] === "Regular";});}}
      {{? isLiveEvent && evParent.length === 0 && !isRegularChildEvent}}
        {{evParent = notParentEvents.find(function(ev) { return ev[28] === parentEvent && (ev[27] === "Sets");}) || [];}}
        {{childEvents = notParentEvents.filter(function(ev) { return ev[28] === parentEvent && ev[27] === "Games";});}}        
      {{?}}
      {{var groupEvents = events.filter(function(e){ return e[28] === parentEvent || e[0] === parentEvent});}}
      {{var periods = groupEvents.reduce(function(pe, e){ return pe.concat(Object.keys(e[8]));}, []);}}
      {{var finalPeriods = [...new Set(periods)];}}
      {{var hasMatchPeriod = finalPeriods.length && finalPeriods[0] === '0';}}
      {{~finalPeriods :p:pIndex}}
        {{? childEvents.length > 0 }}
          {{var childEventSamePeriod = childEvents.filter(function(e){ return Object.keys(e[8]).includes(p) || (e[27] === "Games" && evParent.length > 0 && Object.keys(evParent[8]).includes(p));});}}
          {{? (isSetChildEvent && !isGameChildEvent) || (childEvents.length > 0 && evParent.length > 0 && childEventSamePeriod.length === 0 && Object.keys(evParent[8]).includes(p))}}
            {{childEventSamePeriod.unshift(evParent);}}
          {{?}}
        {{??}}
          {{var childEventSamePeriod = [evParent];}}
        {{?}}
        {{~childEventSamePeriod :ev:ev_index}}
          {{var {isRegularEvent, isSetEvent, isGameEvent, isRegularEventParent, isSetEventParent, isGameEventParent} = getTypeEventTennis(ev, evParent);}}
          {{var eventId = isSetEvent && isRegularEventParent ? ev[0] : (evParent[0] != ev[0]) ? evParent[0] || 0 : 0;}}
          
          {{var event_count = event_count + 1;}}
          {{var sets = isSetEvent ? ev[8][p] || [] : (isSetEventParent || isRegularEventParent ? evParent[8][p] || [] : []);}}
          {{var regular = isRegularEvent ? ev[8][p] || [] : (isRegularEventParent && !isSetEvent ? evParent[8][p] || [] : [] );}}
          {{var games = isGameEvent ? ev[8][p] : [];}}
          {{var isSetsOdds = isGameEvent && (isRegularEventParent || isSetEventParent);}}
          {{var ft = isSetEvent || isSetsOdds ? sets : (isRegularEvent ? regular : []);}}
          {{var set1x2 = ft && ft[0];}}
          {{var game1x2 = games && games[0];}}
          {{var evSets = isSetsOdds ? evParent : (isRegularEvent || isSetEvent ? ev : []);}}
          {{var evGames = isGameEvent ? ev : [];}}
          {{var statusPeriodsLeftSide = ft && ft[9] ? "status_" + ft[9] : "";}}
          {{var statusPeriodsRightSide = games && games[9] ? "status_" + games[9] : "";}}
          {{var setEventId =  !isGameEvent ? ev[0] : !isGameEventParent ? evParent[0]: 0;}}
          {{var gameEventId =  isGameEvent ? ev[0] : isGameEventParent ? evParent[0]: 0;}}

          {{var isSet1x2Online = set1x2 && set1x2[1] != '';}}
          {{var isGame1x2Online = game1x2 && game1x2[1] != '';}}
        
          {{var periodEvent = evParent && evParent[0] !== ev[0] && ev[8] && ev[8][p] ? ev[8][p] : 0;}}
          {{var parentPeriod = evParent && !isSetEvent && evParent[8] && evParent[8][p] ? evParent[8][p] : 0;}}
          {{var periodEventCount = periodEvent && periodEvent[6] ? periodEvent[6] : 0;}}
          {{var parentPeriodEventCount = parentPeriod && parentPeriod[6] ? parentPeriod[6] : 0;}}
          {{var _moreBetsCount = parseInt(periodEventCount) + (evParent.length > 0 ? parseInt(parentPeriodEventCount) : 0);}}
          {{var teamNameEv1 = evParent.length > 0 && !isSetEvent ? evParent[1] :ev[1];}}
          {{var teamNameEv2 = evParent.length > 0 && !isSetEvent ? evParent[2] :ev[2];}}
          {{var isLastestEvent = finalPeriods.length > 1 && finalPeriods.length === pIndex + 1 && isLiveEvent;}}
          {{? isSet1x2Online || isGame1x2Online || _moreBetsCount > 0 }}
            <table class="events tennis no-select events-list sp{{=sp[0]}} pe{{=ev[28]}} {{= p !=='0' && isLiveEvent && hasMatchPeriod ? "isNotMatch hide" : ""}}" border-bottom col-border-bottom" id="e{{=ev[0]}}">
                <tr class='{{=parentEventIndex%2==0?"odd":"even"}} mkline e{{=isSetEventParent ? evParent[0] : ev[0]}}_{{=p}}' id="e{{=ev[0]}}_0" data-eid="{{=eventId}}_{{=ev[0]}}_{{=p}}" data-pid='{{=p}}'>
                    <td class='col-icons main-icons border-left col-border-left'>
                    </td>
                    <td class='col-time main-time border-right'>
                        {{? ev[5]}}
                            {{? ev[9]}}
                                <span>{{=ev[9][0]}}-{{=ev[9][1]}}</span>
                            {{??}}
                                {{? !isParlay}}<span class='liveTm'>{{=i18n('Live')}}</span> {{?}}
                            {{?}}
                            {{? ev[16]}}
                                <span class='liveInfo'>{{=i18n(ev[16])}} {{=ev[15]||''}}</span>
                            {{??}}
                                <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                            {{?}}
                        {{??}}
                            {{? ev[6] && !isBlockedLiveSport && !isBlockedLiveLeague}}
                                <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                                {{? !isParlay}}<span class='liveTm'>{{=i18n('Live')}}</span>{{?}}
                            {{??}}
                                <span>{{=moment(new DateTZ(ev[4])).format(i18n('MM/DD'))}}</span>
                                <span>{{=moment(new DateTZ(ev[4])).format(i18n("HH:mm"))}}</span>
                            {{?}}
                        {{?}}
                    </td>
                    <td class='col-fav main-fav'>
                        <a class="bookmark" data-event-id="{{=evParent[0] || 0 }}_{{=ev[0]}}_{{=p}}" ><i class='fav  icon'></i></a>
                        <div class="fav-custom-tooltip ">
                            <div class="tooltip-wrapper">
                                <span class="tooltip-text">{{=i18n('You have reached the maximum favorites added.')}}</span>
                            </div>
                        </div>
                    </td>
                    <td class='{{=games && (games[3] || games[4])? "": "no-underdog"}} col-name main-name border-right {{=ev[18] || ev[19] ? "lc-icons": ""}}'>
                        {{? !(ev[27] && ev[27].toLowerCase() === 'regular' && parseInt(p) === 0 && isLiveEvent) }}
                            <div class="grading-unit-container">
                            ({{=getPeriodsName(periodsDescription, sp[0], p, false)}})
                            </div>
                        {{?}}
                        <div class="team-name-container">
                            <span title="{{=teamNameEv1}}" class="{{=games && games[3]? 'favSel':'sel'}}">
                                {{=teamNameEv1}}

                            </span>
                            <span title="{{=teamNameEv2}}" class="{{=games && games[4]? 'favSel':'sel'}}">
                                {{=teamNameEv2}}
                            </span>
                        </div>
                    </td>
                    <td class="odds main-odds border-right {{=statusPeriodsLeftSide}}" data-eventid='{{=setEventId}}'>
                        {{? isSet1x2Online}}
                        <a class="odds {{=set1x2[1] < 0 ? 'fav neg' : ''}}"
                        data-oddsid="{{=set1x2[3]}}"
                        data-date="{{=evSets[4]}}"
                        data-pl-res="{{=evSets[22]}}"
                        data-team-type="{{=evSets[11][0]}}"
                        id="{{=evSets[0]}}|{{=p}}|1|0|{{=set1x2[4]?1:0}}|0"
                        >
                            {{? ot === OddsFormat.American}}
                                <span>{{? set1x2[1] > 0}}+{{?}}{{=set1x2[1]}}</span>
                            {{??}}
                                <span>{{=set1x2[1].formatSeparators()}}</span>
                            {{?}}
                        </a>
                        {{??}}&nbsp;
                        {{?}}
                    </td>
                    {{? hasDrawML}}
                    <td class="odds main-odds {{=statusPeriodsLeftSide}}" data-eventid='{{=setEventId}}'>
                        {{? isSet1x2Online && set1x2 && set1x2[2]}}
                        <a class="odds {{=set1x2[2] < 0 ? 'fav neg' : ''}}"
                        data-oddsid="{{=set1x2[3]}}"
                        data-date="{{=evSets[4]}}"
                        data-pl-res="{{=evSets[22]}}"
                        data-team-type="2"
                        id="{{=evSets[0]}}|{{=p}}|1|2|{{=set1x2[4]?1:0}}|0"
                        >
                            {{? ot === OddsFormat.American}}
                                <span>{{? set1x2[2] > 0}}+{{?}}{{=set1x2[2]}}</span>
                            {{??}}
                                <span>{{=set1x2[2].formatSeparators()}}</span>
                            {{?}}
                        </a>
                        {{??}}&nbsp;
                        {{?}}
                    </td>
                    {{?}}
                    <td class="odds main-odds {{=statusPeriodsLeftSide}}" data-eventid='{{=setEventId}}'>
                        {{? isSet1x2Online}}
                        <a class="odds {{=set1x2[0] < 0 ? 'fav neg' : ''}}"
                        data-oddsid="{{=set1x2[3]}}"
                        data-date="{{=evSets[4]}}"
                        data-pl-res="{{=evSets[22]}}"
                        data-team-type="{{=evSets[11][1]}}"
                        id="{{=evSets[0]}}|{{=p}}|1|1|{{=set1x2[4]?1:0}}|0"
                        >
                            {{? ot === OddsFormat.American}}
                                <span>{{? set1x2[0] > 0}}+{{?}}{{=set1x2[0]}}</span>                        
                            {{??}}
                                <span>{{=set1x2[0].formatSeparators()}}</span>
                            {{?}}
                        </a>
                        {{??}}&nbsp;
                        {{?}}
                    </td>
                    <td class="odds main-odds border-left border-right {{=statusPeriodsRightSide}}" data-eventid='{{=gameEventId}}'>
                        {{? isGame1x2Online}}
                        <a class="odds {{=game1x2[1] < 0 ? 'fav neg' : ''}}"
                        data-oddsid="{{=game1x2[3]}}"
                        data-date="{{=evGames[4]}}"
                        data-pl-res="{{=evGames[22]}}"
                        data-team-type="{{=evGames[11][0]}}"
                        id="{{=evGames[0]}}|{{=p}}|1|0|{{=game1x2[4]?1:0}}|0"
                        >
                            {{? ot === OddsFormat.American}}
                                <span>{{? game1x2[1] > 0}}+{{?}}{{=game1x2[1]}}</span>
                            {{??}}
                                <span>{{=game1x2[1].formatSeparators()}}</span>
                            {{?}}
                        </a>
                        {{??}}&nbsp;
                        {{?}}
                    </td>
                    {{? hasDrawML}}
                    <td class="odds main-odds {{=statusPeriodsRightSide}}" data-eventid='{{=gameEventId}}'>
                        {{? isGame1x2Online && game1x2 && game1x2[2]}}
                        <a class="odds {{=game1x2[2] < 0 ? 'fav neg' : ''}}"
                        data-oddsid="{{=game1x2[3]}}"
                        data-date="{{=evGames[4]}}"
                        data-pl-res="{{=evGames[22]}}"
                        data-team-type="2"
                        id="{{=evGames[0]}}|{{=p}}|1|2|{{=game1x2[4]?1:0}}|0"
                        >
                            {{? ot === OddsFormat.American}}
                                <span>{{? game1x2[2] > 0}}+{{?}}{{=game1x2[2]}}</span>
                            {{??}}
                                <span>{{=game1x2[2].formatSeparators()}}</span>
                            {{?}}
                        </a>
                        {{??}}&nbsp;
                        {{?}}
                    </td>
                    {{?}}
                    <td class="odds main-odds {{=statusPeriodsRightSide}}" data-eventid='{{=gameEventId}}'>
                        {{? isGame1x2Online}}
                        <a class="odds {{=game1x2[0] < 0 ? 'fav neg' : ''}}"
                        data-oddsid="{{=game1x2[3]}}"
                        data-date="{{=evGames[4]}}"
                        data-pl-res="{{=evGames[22]}}"
                        data-team-type="{{=evGames[11][1]}}"
                        id="{{=evGames[0]}}|{{=p}}|1|1|{{=game1x2[4]?1:0}}|0"
                        >
                            {{? ot === OddsFormat.American}}
                                <span>{{? game1x2[0] > 0}}+{{?}}{{=game1x2[0]}}</span>
                            {{??}}
                                    <span>{{=game1x2[0].formatSeparators()}}</span>
                            {{?}}
                        </a>
                        {{??}}&nbsp;
                        {{?}}
                    </td>
                    <td class='col-more main-more border-right border-left col-border-right'>
                        <div class='more-content'>
                            {{? _moreBetsCount > 0}}
                                <span id='more_{{=eventId}}_{{=ev[0]}}_{{=p}}' class='more' data-eid="{{=eventId}}_{{=ev[0]}}_{{=p}}" data-pid="{{=p}}">
                                    <span class='more-loading'><i class='fa fa-sync fa-spin'></i></span>
                                    <span class='sign'>+</span>
                                    <span class="more-count">
                                        {{=_moreBetsCount}}
                                    </span>
                                </span>
                            {{?}}
                        </div>
                    </td>
                </tr>
                <tr class="more-bets {{=parentEventIndex%2==0?"odd":"even"}}" id="e{{=eventId}}_{{=ev[0]}}_{{=p}}_more"><td class="more-bets" colspan="{{=!hasDrawML? 9 : 11}}"></td></tr>
            </table>
            {{?}}
            {{~}}<!--Events-->
            {{? isLastestEvent && hasMatchPeriod}}
                <div class="tennis-more-events border-bottom-right border-left {{=parentEventIndex%2==0?"odd":"even"}} pe{{=ev[28]}}">
                    <div class="tennis-more-events-btn" data-event-parent-id={{=ev[28]}}>
                        <span class="show-less pe{{=ev[28]}} hide">
                            {{=i18n("See Less")}}
                            <i class='fas fa-chevron-up'></i>
                        </span>
                        <span class="show-more pe{{=ev[28]}}">
                            {{=i18n("See More")}}
                            <i class='fas fa-chevron-down'></i>
                        </span>
                    </div>
                    <div class="more-market-custom-tooltip">
                        <div class="tooltip-wrapper">
                            <i class="fal fa-times close tooltip-close"></i>
                            <div class="tooltip-title">{{=i18n('More Market Type')}}</div>
                            <div class="tooltip-content">{{=i18n('Click to see more market types')}}</div>
                        </div>
                    </div>
                </div>
            {{?}}
          {{~}}
        {{~}}
        </div>
        {{~}}<!--Leagues-->
        {{? leagues.length ==0}}
            <div class="no-event">{{=i18n('No Events')}}</div>
        {{?}}
    </div>
    {{~}}<!--Sports-->
{{?}}
`;


// WEBPACK FOOTER //
// ./src/app/components/CompactView/OddsPageComponent/Templates/tennisTemplates/TennisMoneyLine1x2.js